import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import mastercard from '@/assets/img/mastercard-logo.svg'
import visa from '@/assets/img/visa-logo.png'
import { cn } from '@bem-react/classname'

import { Logo } from '@/components/UI/Logo'

import { Cookies } from '../Cookies'
import './Footer.scss'

interface IFooter {
  className?: string
  isHome?: boolean
}

const cnFooter = cn('Footer')

export const Footer: FC<IFooter> = ({ className, isHome }: IFooter) => {
  const { t } = useTranslation()

  const [isCookies, setIsCookies] = useState<boolean>(false)

  useEffect(() => {
    const cookies = localStorage.getItem('cookies')
    if (cookies === 'false') {
      setIsCookies(false)
    } else {
      setTimeout(() => {
        setIsCookies(true)
      }, 3000)
    }
  }, [])

  return (
    <>
      <footer className={cnFooter(null, [className])}>
        <div className={cnFooter('container', { home: isHome })}>
          <div className={cnFooter('center', { home: isHome })}>
            <div className={cnFooter('wrap')}>
              <Logo to={isHome ? '/' : '/c'} />
              <div className={cnFooter('menu')}>
                <NavLink
                  to={'/terms-and-conditions'}
                  className={cnFooter('link')}
                >
                  {t('footer-terms-conditions')}
                </NavLink>
                <NavLink to={'/refund-policy'} className={cnFooter('link')}>
                  {t('footer-refund-policy')}
                </NavLink>
                <NavLink to={'/privacy-policy'} className={cnFooter('link')}>
                  {t('footer-privacy-policy')}
                </NavLink>
                <NavLink to={'/kyc-aml-policy'} className={cnFooter('link')}>
                  {t('footer-kyc-aml-policy')}
                </NavLink>
              </div>
            </div>
            <div className={cnFooter('text')}>
              EXERCIAL, s. r. o. <br />
              Registered office/seat: Dunajská 66 Bratislava - mestská časť
              Staré Mesto 811 08, Slovakia
            </div>
            <div className={cnFooter('text')}>
              Company/ID number: 50 031 074
            </div>

            <div className={cnFooter('logos')}>
              <img
                src={mastercard}
                alt='Mastercard logo'
                className={cnFooter('logo')}
              />
              <img src={visa} alt='Visa logo' className={cnFooter('logo')} />
            </div>
          </div>
        </div>
      </footer>
      {isCookies && (
        <Cookies isCookies={isCookies} setIsCookies={setIsCookies} />
      )}
    </>
  )
}
